import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getCityList() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/cities`,
    method: 'get',
  });
}
